export const DEFAULT_CHUNK_SIZE = 12;

export const DEFAULT_MAX_CHUNKS_COUNT = 16;
